import React from "react";
import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/lib/api";

export default function WhatsAppFloat() {
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2 bg-[#059669] hover:bg-[#047857] text-white font-semibold rounded-full px-4 py-3 shadow-lg shadow-emerald-900/30 transition-all hover:-translate-y-0.5"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline text-sm">Chat on WhatsApp</span>
    </a>
  );
}
